module.exports = __webpack_public_path__ + "img/about_a01.144a91a9.svg";